import Header from "../../../components/Header/Header";
import {getAuthData} from "../../../api/fetch";
import {useAuth} from "../../../contexts/auth-context";
import {useEffect, useState} from "react";
import {NewSpinner} from "../../../components/Spinner/NewSpinner";
import {useParams} from "react-router-dom";
import NoMatch from "../../NoMatch/NoMatch";

function Files() {
    const { token, appUser, logout } = useAuth();
    const [ error, setError ] = useState(false);

    let { id, type } = useParams();

    const FILE_TYPE_MAP = {
        cv: "cv",
        cijferlijst: "gradeList",
        motivatiebrief: "motivationLetter",
    };
    const fileType = FILE_TYPE_MAP[type] || null;

    useEffect(() => {
        if (!token || !appUser || !id || !fileType) return;

        const isSafeRedirectUrl = (rawUrl) => {
            try {
                const u = new URL(rawUrl);
                return (u.protocol === "https:" || u.protocol === "http:") && u.host === process.env.REACT_APP_API_HOST;
            } catch (e) {
                return false;
            }
        };

        const getStudentData = async () => {
            try {
                const studentData = await getAuthData(`website/students/${id}/files/${fileType}`, appUser, token, logout);
                if (!studentData?.url || !isSafeRedirectUrl(studentData.url)) {
                    setError(true);
                    return;
                }
                window.location.replace(studentData.url);
            } catch (e) {
                setError(true);
            }
        }

        getStudentData();
    }, [token, appUser, logout, id, fileType])

    if (error || !fileType) return <NoMatch />

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <NewSpinner />
            </div>
        </div>
    );
}

export default Files;